import {inject, NgZone} from '@angular/core';

export abstract class SchedulingService {

  abstract scheduleLowPriorityTask(task: () => void, timeout?: number): void;

}

export class BrowserSchedulingService extends SchedulingService {

  private readonly ngZone = inject(NgZone);

  scheduleLowPriorityTask(task: () => void, timeout: number = 5000) {
    this.ngZone.runOutsideAngular(() => {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(task, {timeout});
      } else {
        setTimeout(task, timeout);
      }
    });
  }

}

export class ServerSchedulingService extends SchedulingService {

  scheduleLowPriorityTask(_task: () => void) {
  }

}
